import { contractBook } from '@eulerxyz/core-sdk'
import { mapToEVCCall } from '@eulerxyz/evc-sdk'
import { Permit2TransactionFactory, type PermitSingleTransactionItem } from '@eulerxyz/wagmi-evc'

interface SimulationDataLike {
  request: Record<string, unknown> & { args?: unknown[][] }
}

/**
 * Prepends a Permit2.permit EVC call to the simulated batch and returns
 * a ready-to-write execution request.
 *
 * Uses the full simulated args (including oracle update calls) so that
 * on-chain execution matches the oracle state assumed during simulation.
 *
 * If `permitTx` is null the original simulation request is returned unchanged.
 */
export function buildPermit2BatchRequest({
  simulationData,
  permitTx,
  chainId,
}: {
  simulationData: SimulationDataLike
  permitTx: PermitSingleTransactionItem | null
  chainId: number
}): Record<string, unknown> {
  if (!permitTx) {
    return simulationData.request
  }

  const permit2Factory = new Permit2TransactionFactory(chainId as ConstructorParameters<typeof Permit2TransactionFactory>[0], contractBook)
  const permitCalls = permit2Factory.typeGuardConvertMultiple([permitTx])
  const permitEvcCalls = mapToEVCCall(permitCalls)

  const baseEvcCalls = (simulationData.request.args?.[0] as unknown[]) || []
  const fullEvcCalls = [...permitEvcCalls, ...baseEvcCalls]

  return {
    ...simulationData.request,
    args: [fullEvcCalls],
  }
}
